import { birthYearsPreview, birthYearsWarning } from "../lib/tournamentDivisions";

/** Debajo de «Nacidos desde / hasta»: qué edades acepta la categoría y aviso
 * si el rango parece invertido. */
export default function BirthYearFeedback({
  name,
  ageMin,
  ageMax,
  tournamentYear,
}: {
  name: string;
  ageMin: string;
  ageMax: string;
  tournamentYear: number;
}) {
  const preview = birthYearsPreview(ageMin, ageMax, tournamentYear);
  const warning = birthYearsWarning(name, ageMin, ageMax);
  if (!preview && !warning) return null;
  return (
    <div className="birth-year-feedback" data-no-toast>
      {preview ? <p className="muted">{preview}</p> : null}
      {warning ? (
        <p className="birth-year-feedback__warning" role="status">
          {warning}
        </p>
      ) : null}
    </div>
  );
}
